import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const router = new Router({
    mode: 'hash',
    base: 'ai-lab',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@/presentation/pages/ai-home/AiHome.vue'),
        },
        {
            path: '/search',
            name: 'ai-search',
            component: () => import('@/presentation/pages/ai-search/AiSearch.vue'),
        },
        {
            path: '/clms',
            name: 'ai-clms',
            component: () => import('@/presentation/pages/ai-clms/AiClms.vue'),
        },
        {
            path: '/image',
            name: 'ai-image',
            component: () => import('@/presentation/pages/ai-image/AiImage.vue'),
        },
        {
            path: '/translation',
            name: 'ai-translation',
            component: () => import('@/presentation/pages/ai-translation/AITranslation.vue'),
        },
        {
            path: '/disclosure',
            name: 'ai-disclosure',
            component: () => import('@/presentation/pages/ai-disclosure/AIDisclosure.vue'),
        },
    ],
});
